// frontend/src/screens/forum/ForumThreadDetail.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { getThread, getThreadPosts } from '../../services/forumApi';
import { authorLabel } from '../../utils/forumUiHelpers';
import { localizedValue } from '../../localization/presentationLanguage';
const forumText = (es, en) => localizedValue({ es, en });




export default function ForumThreadDetail() {
  const { slug } = useParams();
  const navigate = useNavigate();

  const [thread, setThread] = useState(null);
  const [posts, setPosts] = useState([]);
  const [err, setErr] = useState('');

  const POSTS_PAGE_SIZE = 20;
  const [visibleCount, setVisibleCount] = useState(POSTS_PAGE_SIZE);
  const visiblePosts = Array.isArray(posts) ? posts.slice(0, visibleCount) : [];
  const hasMorePosts = Array.isArray(posts) && posts.length > visibleCount;

  const [hoverBack, setHoverBack] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const [threadData, postsData] = await Promise.all([
          getThread(slug),
          getThreadPosts(slug),
        ]);

        setThread(threadData?.thread || threadData || null);
        setPosts(Array.isArray(postsData?.items) ? postsData.items : (postsData?.posts || []));
        setVisibleCount(POSTS_PAGE_SIZE);
        setErr('');
      } catch (e) {
        setErr(e.message || 'Error');
      }
    })();
  }, [slug]);

  return (
    <HelmetProvider>
      <div style={styles.page}>
        <Helmet>
          <title>{thread?.title ? `${thread.title} | Zodiacus` : 'Tema del foro | Zodiacus'}</title>
        </Helmet>

        <div style={styles.shell}>
          {/* Top bar */}
          <div style={styles.topBar}>
            <button
              onClick={() => navigate('/foro')}
              onMouseEnter={() => setHoverBack(true)}
              onMouseLeave={() => setHoverBack(false)}
              style={{ ...styles.backBtn, ...(hoverBack ? styles.backBtnHover : null) }}
              title={forumText('Volver al índice', 'Back to forum index')}
            >
              {forumText('← Volver', '← Back')}
            </button>
          </div>

          {/* Card container */}
          <div style={styles.card}>
            {err && <div style={styles.error}>{err}</div>}

            {!thread ? (
              <div style={styles.empty}>
                <div style={styles.emptyEmoji}>💬</div>
                <div style={styles.emptyTitle}>{forumText('Cargando hilo...', 'Loading thread...')}</div>
              </div>
            ) : (
              <div>
                <h2 style={{ marginBottom: 10 }}>{thread.title}</h2>

                <div style={{ marginBottom: 20, color: '#6a5aa5', fontSize: 13 }}>
                  {forumText('Iniciado por', 'Started by')} {authorLabel(thread)} · {new Date(thread.createdAt).toLocaleDateString()}
                </div>

                <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
                  {visiblePosts.map(p => (
                    <div key={p._id} style={{
                      border:'1px solid #eee',
                      borderRadius:12,
                      padding:14,
                      background:'#fff'
                    }}>
                      <div style={{ fontWeight:700, marginBottom:6 }}>
                        {p.authorFullName || forumText('Usuario', 'User')}
                      </div>

                      <div style={{ fontSize:14, lineHeight:1.5 }}>
                        {p.content}
                      </div>

                      <div style={{ fontSize:12, marginTop:6, color:'#777' }}>
                        {new Date(p.createdAt).toLocaleString()}
                      </div>
                    </div>
                  ))}
                </div>
                {hasMorePosts && (
                  <div style={{ display:'flex', justifyContent:'center', marginTop:16 }}>
                    <button
                      type="button"
                      onClick={() => setVisibleCount((prev) => prev + POSTS_PAGE_SIZE)}
                      style={styles.loadMoreBtn}
                    >
                      {forumText(`Ver más respuestas (${posts.length - visibleCount} restantes)`, `View more replies (${posts.length - visibleCount} remaining)`)}
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </HelmetProvider>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    padding: '24px 16px',
    display:'flex',
    alignItems:'center',
    justifyContent:'center',
    background: 'radial-gradient(1200px 600px at 10% -20%, rgba(218,165,32,0.22), transparent), radial-gradient(1200px 600px at 110% 120%, rgba(75,0,130,0.22), transparent), linear-gradient(135deg, #2d084c 0%, #4B0082 60%, #1a0b38 100%)',
  },
  shell: { width:'100%', maxWidth: 1040 },

  topBar: {
    display:'flex',
    alignItems:'center',
    justifyContent:'space-between',
    marginBottom: 14,
    gap: 12,
  },

  // ⬇️ NUEVOS estilos del select
  sortWrap: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  sortLabel: {
    color: '#4B0082',
    fontWeight: 800,
    fontSize: 12,
    background: 'rgba(218,165,32,0.12)',
    border: '1px solid rgba(218,165,32,0.35)',
    padding: '6px 8px',
    borderRadius: 8,
  },
  sortSelect: {
    appearance: 'none',
    WebkitAppearance: 'none',
    MozAppearance: 'none',
    background: 'linear-gradient(180deg, #FFF8E1, #FFFFFF)',
    border: '1px solid #4B008233',
    color: '#2d084c',
    fontWeight: 800,
    borderRadius: 10,
    padding: '8px 28px 8px 10px',
    boxShadow: '0 4px 12px rgba(218,165,32,0.10) inset',
    cursor: 'pointer',
  },

  backBtn: {
    border:'1px solid #4B008222',
    background:'linear-gradient(90deg, #DAA520 0%, #FFD54F 100%)',
    color:'#fff',
    padding:'10px 14px',
    borderRadius:12,
    cursor:'pointer',
    boxShadow:'0 6px 16px rgba(218,165,32,0.28)',
    backdropFilter:'blur(6px)',
  },
  backBtnHover: { transform:'translateY(-1px) scale(1.02)', boxShadow:'0 8px 20px rgba(218,165,32,0.28)' },

  ctaBtn: {
    border:'1px solid #4B008222',
    background:'linear-gradient(90deg, #DAA520, #FFD54F)',
    color:'#fff',
    padding:'10px 16px',
    borderRadius:12,
    cursor:'pointer',
    fontWeight:800,
    boxShadow:'0 10px 24px rgba(218,165,32,0.30)',
  },
  ctaBtnHover: { transform:'translateY(-1px)', boxShadow:'0 12px 28px rgba(218,165,32,0.35)' },

  hero: {
    display:'flex',
    alignItems:'center',
    gap:16,
    background:'linear-gradient(135deg, rgba(218,165,32,0.18), rgba(75,0,130,0.18))',
    border:'1px solid rgba(218,165,32,0.45)',
    borderRadius:16,
    padding:16,
    boxShadow:'0 16px 48px rgba(44,13,78,0.35)',
    color:'#fff',
    backdropFilter:'blur(8px)',
    marginBottom: 16,
  },
  emojiWrap: {
    width:56, height:56,
    borderRadius:'50%',
    background:'rgba(218,165,32,0.18)',
    border:'2px solid #DAA520',
    display:'flex', alignItems:'center', justifyContent:'center',
    boxShadow:'0 8px 24px rgba(218,165,32,0.28)',
    flexShrink:0,
  },
  emoji: { fontSize: 28, lineHeight: 1 },
  heroText: { display:'flex', flexDirection:'column', minWidth:0 },

  title: {
    margin:0,
    fontWeight:900,
    fontSize: 'clamp(1.35rem, 2.8vw, 2rem)',
    letterSpacing: 0.2,
    background: 'linear-gradient(90deg, #FFFFFF 0%, #ffe082 40%, #FFFFFF 80%)',
    WebkitBackgroundClip: 'text',
    backgroundClip: 'text',
    color: 'transparent',
    textShadow: '0 2px 16px rgba(218,165,32,0.25)'
  },
  subtitle: {
    marginTop: 4,
    color:'rgba(255,255,255,0.92)',
    fontSize: 13,
    textShadow:'0 1px 10px rgba(75,0,130,0.18)',
  },

  card: {
    width:'100%',
    background:'rgba(255,255,255,0.98)',
    borderRadius:16,
    padding:18,
    boxShadow:'0 16px 48px rgba(44,13,78,0.18), 0 2px 8px rgba(218,165,32,0.09)',
    border:'1px solid #DAA52022',
    backdropFilter:'blur(6px)',
  },
  error: { color:'#a00', marginTop:8 },

  empty: {
    display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center',
    padding:'32px 16px',
    color:'#2d084c',
  },
  emptyEmoji: { fontSize:42, marginBottom:8 },
  emptyTitle: { fontWeight:900, fontSize:18 },
  emptySub: { color:'#6a5aa5', marginTop:4, marginBottom:12, opacity:0.95 },
  ctaGhost: {
    border:'1px solid #DAA520',
    background:'linear-gradient(180deg, rgba(218,165,32,0.14), rgba(218,165,32,0.08))',
    color:'#4B0082',
    fontWeight:800,
    padding:'10px 14px',
    borderRadius:12,
    cursor:'pointer',
    boxShadow:'0 6px 16px rgba(218,165,32,0.22)',
    transition:'transform .12s ease, box-shadow .12s ease',
  },

  list:{ listStyle:'none', padding:0, margin:'10px 0 0', display:'flex', flexDirection:'column', gap:8 },
  li: { padding:0, margin:0 },
  threadLink: { textDecoration:'none', color:'inherit' },

  thread: {
    display:'flex',
    alignItems:'center',
    justifyContent:'space-between',
    gap:12,
    padding:'16px 14px',
    borderRadius:14,
    border:'1px solid #4B008233',
    background:'linear-gradient(180deg, #FFF8E1, #FFFFFF)',
    boxShadow:'0 10px 24px rgba(218,165,32,0.10)',
    transition:'transform .10s ease, box-shadow .14s ease',
  },
  threadHover: { transform:'translateY(-1px) scale(1.01)', boxShadow:'0 12px 28px rgba(218,165,32,0.18), inset 0 0 0 1px rgba(255,255,255,0.8)' },
  threadLeft: { minWidth:0, flex:1 },
  tTitle: {
    fontWeight:900, color:'#2d084c', marginBottom:6, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap',
  },

  meta: { display:'flex', alignItems:'center', flexWrap:'wrap', gap:8, fontSize:12, color:'#4B0082' },
  metaChip: {
    background:'rgba(218,165,32,0.10)',
    border:'1px solid rgba(218,165,32,0.35)',
    borderRadius:999,
    padding:'4px 8px',
    color:'#2d084c',
  },
  metaDot: { color:'#DAA520' },
  metaTime: { color:'#6a5aa5' },

  threadRight: { fontSize:18, color:'#4B0082', flexShrink:0, marginLeft:8 },

  pager: { display:'flex', alignItems:'center', justifyContent:'center', gap:12, marginTop:16 },
  pagerBtn: {
    border:'1px solid #4B008222',
    background:'linear-gradient(90deg, #DAA520 0%, #FFD54F 100%)',
    color:'#fff',
    padding:'10px 14px',
    borderRadius:10,
    cursor:'pointer',
    fontWeight:800,
    boxShadow:'0 8px 22px rgba(218,165,32,0.26)',
  },
  pagerBtnDisabled: { filter:'grayscale(0.5)', opacity:0.7, cursor:'default', boxShadow:'none' },
  pagerBtnHover: { transform:'translateY(-1px)', boxShadow:'0 10px 26px rgba(218,165,32,0.30)' },
  pagerInfo: { color:'#4B0082', fontWeight:700 },

  loadMoreBtn: {
    border:'1px solid #DAA520',
    background:'linear-gradient(180deg, rgba(218,165,32,0.16), rgba(218,165,32,0.08))',
    color:'#4B0082',
    fontWeight:800,
    padding:'10px 16px',
    borderRadius:12,
    cursor:'pointer',
    boxShadow:'0 8px 20px rgba(218,165,32,0.16)',
  },
};
